module.exports = __webpack_public_path__ + "media/images/logo-3e9f5054a637273dcde6ce72680eb8ce.png";